import React from "react";
import "./SummitHighlight.scss";

const SummitHighlight = () => {
  const highlights = [
    {
      icon: "fa fa-briefcase",
      title: "100+ Stalls",
      description:
        "Showcasing successful business cash flow journeys and real-world implementations",
    },
    {
      icon: "fa fa-clipboard",
      title: "1000+ Seats",
      description:
        "In Conference Area for interactive sessions and live learning experiences",
    },
    {
      icon: "fa fa-users",
      title: "10,000+ Participants",
      description:
        "Entrepreneurs & Business Owners networking and sharing insights together",
    },
    {
      icon: "fa fa-desktop",
      title: "Special Workshops",
      description:
        "On Mastering Collections, Managing Cash & Scaling, and Late Payment Solutions",
    },
  ];

  return (
    <section className="summit-highlight-section">
      <div className="container">
        {/* Badge */}
        <div className="highlight-badge">
          <i className="fa fa-star"></i>
          <span>Summit Highlights</span>
        </div>

        {/* Title */}
        <div className="highlight-title-wrapper">
          <h2>What Makes This Summit Extraordinary</h2>
        </div>

        {/* Cards Grid */}
        <div className="highlights-grid">
          {highlights.map((highlight, index) => (
            <div key={index} className="highlight-card">
              <div className="highlight-icon">
                <i className={highlight.icon}></i>
              </div>
              <h3 className="highlight-card-title">{highlight.title}</h3>
              <p className="highlight-card-description">
                {highlight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SummitHighlight;
